<a [routerLink]="item.route" routerLinkActive="active" [class.btn-disabled]="item.disabled" [tabIndex]="item.disabled ? -1 : 0">
    <span>{{ item.name | translate }}</span>
</a>
